import { type SelectOption } from '../../../../../components';
import { PAGE_TEXT } from '../lang';
import { REFEREE_TITLE_TYPE } from '../constants';

const academicTypeText =
  PAGE_TEXT.OTHER_INFORMATION.ACADEMIC_REFEREE.REFEREE_TITLE_OPTIONS;
const academicTypeKeys: string[] = Object.keys(academicTypeText);

export const academicRefereeTypeOptions: SelectOption[] = Object.values(
  academicTypeText,
).map((label: string, index: number) => ({
  value:
    REFEREE_TITLE_TYPE[
      academicTypeKeys[index] as keyof typeof REFEREE_TITLE_TYPE
    ],
  label,
}));

export const titleTypeOptions: SelectOption[] = academicTypeKeys
  .filter(key => !['SIR', 'MADAM', 'OTHERS'].includes(key))
  .map(key => ({
    value: REFEREE_TITLE_TYPE[key as keyof typeof REFEREE_TITLE_TYPE],
    label: academicTypeText[key as keyof typeof academicTypeText],
  }));
